export default __webpack_public_path__ + "static/screen-classic-mac-laptop-266634aa22a6f3d0f829373d35f49dfa.png";